var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_attendanceModifiReason_form_editTitle")
        : _vm.$t("label_essweb_attendanceModifiReason_form_viewTitle"),
      delBtn: "",
      backgroundClass: "white",
      initData: _vm.ReasonData,
      checkData: [
        "attendance_modification_reason_name",
        "sequence",
        "attendance_modification_reason_description",
        "attendance_modification_reason_code",
        "remarks",
      ],
      editBtn: !_vm.iSEdited,
      widthClass: "max-1000",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_attendanceModifiReason_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            maxlength: "100",
                            bindData:
                              _vm.ReasonData
                                .attendance_modification_reason_name,
                            label: _vm.$t(
                              "label_essweb_attendanceModifiReason_form_attendancModifiReasonLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.ReasonData.attendance_modification_reason_name =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_attendanceModifiReason_form_sequenceLabel"
                            ),
                            isNotRequire: "",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            maxlength: "255",
                            type: "number",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 255]
                            ),
                          },
                          model: {
                            value: _vm.ReasonData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.ReasonData, "sequence", $$v)
                            },
                            expression: "ReasonData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_attendanceModifiReason_form_codeLabel"
                            ),
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            maxlength: "50",
                          },
                          model: {
                            value:
                              _vm.ReasonData
                                .attendance_modification_reason_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ReasonData,
                                "attendance_modification_reason_code",
                                $$v
                              )
                            },
                            expression:
                              "ReasonData.attendance_modification_reason_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            bindData:
                              _vm.ReasonData
                                .attendance_modification_reason_description,
                            maxlength: "500",
                            label: _vm.$t(
                              "label_essweb_attendanceModifiReason_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.ReasonData.attendance_modification_reason_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_attendanceModifiReason_form_remakLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "single-line": "",
                            name: "input-7-4",
                          },
                          model: {
                            value: _vm.ReasonData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.ReasonData, "remarks", $$v)
                            },
                            expression: "ReasonData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }